import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var Textarea = /*#__PURE__*/function (_Component) {
  _inherits(Textarea, _Component);
  var _super = _createSuper(Textarea);
  function Textarea() {
    var _this;
    _classCallCheck(this, Textarea);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      value: _this.props.value
    });
    return _this;
  }
  _createClass(Textarea, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.value) {
        this.inputElement.value = this.props.value;
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if ((nextProps.value || nextProps.value === '') && this.props.value !== nextProps.value) {
        this.setState({
          value: nextProps.value
        });
      }
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.state.value;
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      if (this.props.onFocus) {
        this.props.onFocus(this.state.value);
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      if (this.props.onBlur) {
        this.props.onBlur(this.state.value);
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var onChange = this.props.onChange;
      var value = event.target.value;
      this.setState({
        value: value
      });
      if (onChange) onChange(value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        placeholder = _this$props.placeholder,
        autoFocus = _this$props.autoFocus,
        maxLength = _this$props.maxLength,
        onSubmit = _this$props.onSubmit,
        disabled = _this$props.disabled,
        readOnly = _this$props.readOnly,
        height = _this$props.height,
        action = _this$props.action,
        resize = _this$props.resize,
        status = _this$props.status,
        value = _this$props.value,
        width = _this$props.width,
        name = _this$props.name,
        id = _this$props.id;
      return /*#__PURE__*/React.createElement("div", {
        action: action,
        onBlur: function onBlur() {
          return _this2.handleBlur();
        },
        onFocus: function onFocus() {
          return _this2.handleFocus();
        },
        onSubmit: onSubmit,
        "data-t-id": "components-Textarea"
      }, /*#__PURE__*/React.createElement("textarea", {
        className: cx('field', status),
        id: id,
        name: name,
        style: {
          height: height,
          width: width,
          resize: resize
        },
        value: value,
        autoFocus: autoFocus,
        disabled: disabled,
        maxLength: maxLength,
        placeholder: placeholder,
        readOnly: readOnly,
        onChange: function onChange(e) {
          return _this2.handleChange(e);
        },
        ref: function ref(c) {
          _this2.inputElement = c;
        }
      }));
    }
  }]);
  return Textarea;
}(Component);
_defineProperty(Textarea, "defaultProps", {
  placeholder: null,
  autoFocus: false,
  disabled: false,
  readOnly: false,
  maxLength: null,
  resize: 'none',
  height: '80px',
  width: '100%',
  value: ''
});
export { Textarea as default };
Textarea.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Текст внутри текстового поля */
  placeholder: PropTypes.string,
  /** Максимальная длинна */
  maxLength: PropTypes.string,
  /** Автоматический фокус */
  autoFocus: PropTypes.bool,
  /** Дополнительный сласс отображения textarea */
  status: PropTypes.string,
  /** Callback, срабатывает при изменении value в textarea */
  onChange: PropTypes.func,
  /** Можно ли пользователю изменять размеры текстового поля */
  resize: PropTypes.string,
  /** Блокирует доступ к активации для textarea */
  disabled: PropTypes.bool,
  /** Может ли текстовое поле изменяться пользователем */
  readOnly: PropTypes.bool,
  /** ? */
  action: PropTypes.string,
  /** Callback */
  onSubmit: PropTypes.func,
  /** Callback, срабатывает при фокусе */
  onFocus: PropTypes.func,
  /** Ширина элемента textarea */
  width: PropTypes.string,
  /** Высота элемента textarea */
  height: PropTypes.string,
  /** Текст внутри textarea */
  value: PropTypes.string,
  /** Уникальное имя элемента */
  name: PropTypes.string,
  /** Callback, срабатывает при расфокусировки */
  onBlur: PropTypes.func,
  /** Уникальный идентификатор для textarea */
  id: PropTypes.string
} : {};